module.exports = __webpack_public_path__ + "SF-UI-Display-Light.e7dd4618689ef9cc9c31.otf";


//////////////////
// WEBPACK FOOTER
// D:/UI-PROJECTS/Helpline1097-UI/src/fonts/SF-UI-Display/SF-UI-Display-Light.otf
// module id = ../../../../../src/fonts/SF-UI-Display/SF-UI-Display-Light.otf
// module chunks = 2